var _style, _circle, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSpxuIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 881.2 881.2",
    style: {
      enableBackground: "new 0 0 881.2 881.2"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#3757DF;}\n\t.st1{fill:#FFFFFF;}\n")), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    className: "st0",
    cx: 440.6,
    cy: 440.6,
    r: 440.6
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M212.7,399.1c-0.8-7.7-4-13.6-9.8-17.9c-5.8-4.3-13.6-6.4-23.5-6.4c-6.7,0-12.4,0.9-17,2.8 c-4.6,1.9-8.2,4.5-10.6,7.8c-2.4,3.3-3.7,7-3.7,11.2c-0.1,3.5,0.6,6.5,2.2,9.1c1.6,2.6,3.9,4.8,6.7,6.7c2.9,1.9,6.2,3.5,9.9,4.9 c3.7,1.4,7.7,2.5,12,3.5l17.5,4.2c8.5,1.9,16.3,4.4,23.4,7.6c7.1,3.2,13.3,7.1,18.5,11.7c5.2,4.6,9.3,10.1,12.1,16.4 c2.9,6.3,4.4,13.5,4.4,21.6c-0.1,11.9-3.1,22.3-9.1,31c-6,8.7-14.6,15.5-25.9,20.3c-11.3,4.8-24.8,7.2-40.7,7.2 c-15.7,0-29.4-2.4-41.1-7.2c-11.7-4.8-20.7-12-27.2-21.5c-6.5-9.5-9.9-21.3-10.2-35.3h39.9c0.4,6.5,2.3,12,5.7,16.3 c3.3,4.3,7.8,7.6,13.4,9.8c5.6,2.2,12,3.3,19.1,3.3c7,0,13.1-1,18.2-3c5.2-2,9.2-4.9,12-8.5c2.9-3.6,4.3-7.8,4.3-12.5 c0-4.4-1.3-8.1-3.9-11c-2.6-3-6.3-5.5-11.2-7.6c-4.9-2.1-10.9-4-18-5.7l-21.2-5.3c-16.4-4-29.4-10.3-39-18.8s-14.3-20-14.2-34.4 c-0.1-11.8,3.1-22.1,9.5-31c6.4-8.8,15.2-15.7,26.3-20.7c11.2-5,23.9-7.4,38.1-7.4c14.5,0,27.1,2.5,38,7.4 c10.8,5,19.3,11.8,25.3,20.7c6,8.8,9.1,19,9.3,30.7H212.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M272.9,538.1V343h77c14.8,0,27.4,2.8,37.8,8.4c10.4,5.6,18.4,13.4,23.9,23.3c5.5,9.9,8.2,21.4,8.2,34.3 s-2.8,24.4-8.4,34.3c-5.6,9.9-13.7,17.6-24.2,23.1s-23.3,8.3-38.3,8.3h-49v-33h42.4c7.9,0,14.5-1.4,19.7-4.1s9-6.6,11.6-11.5 c2.6-4.9,3.9-10.6,3.9-17c0-6.5-1.3-12.1-3.9-17c-2.6-4.9-6.5-8.6-11.7-11.3c-5.2-2.7-11.8-4-19.8-4h-27.8v161.3H272.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M475.6,343l39.3,66.5h1.5L556,343h46.6L543,440.6l60.9,97.5h-47.4l-40-66.6h-1.5l-40,66.6h-47.2l61-97.5 L428.8,343H475.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M739.4,343h41.2v126.7c0,14.2-3.4,26.7-10.1,37.3c-6.8,10.7-16.2,19-28.3,24.9c-12.1,5.9-26.3,8.9-42.4,8.9 c-16.2,0-30.3-3-42.5-8.9c-12.1-5.9-21.6-14.2-28.3-24.9c-6.7-10.7-10.1-23.1-10.1-37.3V343h41.2v123.1c0,7.4,1.6,14,4.9,19.8 c3.3,5.8,7.9,10.3,13.9,13.6c6,3.3,12.9,5,20.9,5c8,0,15-1.7,20.9-5c5.9-3.3,10.5-7.8,13.8-13.6c3.3-5.8,4.9-12.4,4.9-19.8V343z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSpxuIcon);
export default __webpack_public_path__ + "static/media/spxu_icon.76cea8d39ee7e1f2c41c1cb78839b295.svg";
export { ForwardRef as ReactComponent };